import React from 'react';
import CopyButton from '../../../../components/Controls/CopyButton/CopyButton';

interface IProps {
  data: string;
  address: string;
  onClick: () => void;
}

export default class OrderBlockItemAddress extends React.Component<IProps, {}> {
  render() {
    return (
      <div className="d-flex flex-row align-items-center">
        <button className="family-medium text-size-14 color-mainblue text-start p-0" onClick={this.props.onClick}>
          {this.props.data}
        </button>
        <CopyButton data={this.props.address} size={18} tooltipMessage="copied_to_clickboard" />
      </div>
    );
  }
}
